/* eslint-disable security/detect-object-injection */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState } from 'react';
import { IMoeKwrHomepageViewProps } from './moe-kwr-homepage';
import { EnagageModal } from '../../components/engagemodal.component';
import { CategoryModal } from '../../components/categorymodal.component';
import { CurriculaModal } from '../../components/curriculamodal.component';
import { getUrlSync, getAsset } from '@msdyn365-commerce/core';
import { IMenuItemData } from './moe-kwr-homepage.data';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
// import { getToggleLang } from '../../utilities/language-change';
import {
    ENGLISH_LANG,
    ENGLISH_LANG_CODE,
    ENGLISH_TOGGLE_PREFIX,
    MAORI_LANG,
    MAORI_LANG_CODE,
    MAORI_TOGGLE_PREFIX,
    AXE_MAORI_LANG_CODE
} from '../../utilities/constants';
// import { ICmsNavItemsData, ISubMenusData } from './moe-kwr-homepage.props.autogenerated';

export interface IKwrHomePageLanguageAttributes {
    languageText: string;
    atuaTabName: string;
    engageTabName: string;
    curriculaTabName: string;
    searchTabName: string;
    closeText: string;
    introSearchText1: string;
    introSearchText2: string;
    trySearchText: string;
    introAtuaSearchText: string;
    introAtuaBlurbTextRanguini: string;
    introAtuaBlurbTextPapatuanuku: string;
    introAtuaBlurbTextTangaroa: string;
    introAtuaBlurbTextTane: string;
    introAtuaBlurbTextTumatauenga: string;
    introAtuaBlurbTextRongo: string;
    introAtuaBlurbTextHaumia: string;
    introAtuaBlurbTextTawhirimatea: string;
    introAtuaBlurbTextHineahuone: string;
    introAtuaBlurbTextWhiro: string;
    introAtuaBlurbTextRuaumoko: string;
    backButtonText: string;
    curatedCollections: string;
    newsEvents?: string;
}

export default (props: IMoeKwrHomepageViewProps) => {
    const [categoryMemuIsActive, setCategoryMemuIsActive] = useState(false);
    const [engageMenuIsActive, setEngageMenuIsActive] = useState(false);
    const [curriculaMenuIsActive, setCurriculaMenuIsActive] = useState(false);
    const { menuItemData, config, resources, context, data } = props;
    const engageSubMenu = (config.cmsNavItems && config.cmsNavItems.length > 0 && config.cmsNavItems[0]) || undefined;
    const curriculaSubMenu = (config.cmsNavItems && config.cmsNavItems.length > 1 && config.cmsNavItems[1]) || undefined;
    const searchURL = getUrlSync('search', props.context.actionContext) || '';

    // bug 102348: Effect for changing document lang code to Maori
    React.useEffect(() => {
        const htmlElement: HTMLElement | null = document.querySelector('html');
        if (htmlElement) {
            htmlElement.lang = AXE_MAORI_LANG_CODE;
        }
    }, []);

    // const { requestUrl } = props.context.request.url;
    // Identifying Language
    const toggleLang = context.request.locale.toLowerCase() === MAORI_LANG_CODE ? MAORI_LANG : ENGLISH_LANG;
    let userLang = context.request.user.isAuthenticated && data.customerInformation.result && data.customerInformation.result.Language;
    if (userLang) {
        userLang = userLang.toLowerCase() === MAORI_LANG_CODE ? ENGLISH_LANG : MAORI_LANG;
    }
    const userPrefLang = userLang || toggleLang;
    const preferredLanguage: any = userPrefLang === ENGLISH_LANG && toggleLang === ENGLISH_LANG ? ENGLISH_LANG : MAORI_LANG;

    // Changing language based on preferred language
    const appendLangWord = preferredLanguage === MAORI_LANG ? 'InMaori' : '';
    const KwrHomePageLanguageAttributes: IKwrHomePageLanguageAttributes = {
        languageText: resources[`languageText${appendLangWord}`],
        atuaTabName: resources[`atuaTabName${appendLangWord}`],
        engageTabName: resources[`engageTabName${appendLangWord}`],
        curriculaTabName: resources[`curriculaTabName${appendLangWord}`],
        searchTabName: resources[`searchTabName${appendLangWord}`],
        closeText: resources[`closeText${appendLangWord}`],
        introSearchText1: resources[`introSearchText1${appendLangWord}`],
        introSearchText2: resources[`introSearchText2${appendLangWord}`],
        trySearchText: resources[`trySearchText${appendLangWord}`],
        introAtuaSearchText: resources[`introAtuaSearchText${appendLangWord}`],
        introAtuaBlurbTextRanguini: resources[`introAtuaBlurbTextRanguini${appendLangWord}`],
        introAtuaBlurbTextPapatuanuku: resources[`introAtuaBlurbTextPapatuanuku${appendLangWord}`],
        introAtuaBlurbTextTangaroa: resources[`introAtuaBlurbTextTangaroa${appendLangWord}`],
        introAtuaBlurbTextTane: resources[`introAtuaBlurbTextTane${appendLangWord}`],
        introAtuaBlurbTextTumatauenga: resources[`introAtuaBlurbTextTumatauenga${appendLangWord}`],
        introAtuaBlurbTextRongo: resources[`introAtuaBlurbTextRongo${appendLangWord}`],
        introAtuaBlurbTextHaumia: resources[`introAtuaBlurbTextHaumia${appendLangWord}`],
        introAtuaBlurbTextTawhirimatea: resources[`introAtuaBlurbTextTawhirimatea${appendLangWord}`],
        introAtuaBlurbTextHineahuone: resources[`introAtuaBlurbTextHineahuone${appendLangWord}`],
        introAtuaBlurbTextWhiro: resources[`introAtuaBlurbTextWhiro${appendLangWord}`],
        introAtuaBlurbTextRuaumoko: resources[`introAtuaBlurbTextRuaumoko${appendLangWord}`],
        backButtonText: resources[`backButtonText${appendLangWord}`],
        curatedCollections: resources[`curatedCollections${appendLangWord}`]
    };

    console.table(KwrHomePageLanguageAttributes);

    // const handleLangToggle = (langCode: string) => {
    //     const splitPath = requestUrl.pathname.split('/');
    //     if (splitPath[1].toLowerCase() === 'en-nz' || splitPath[1].toLowerCase() === 'mi-nz') {
    //         splitPath[1] = langCode;
    //     } else {
    //         splitPath.splice(1, 0, langCode);
    //     }
    //     let pathUrl = '';
    //     splitPath.forEach(ch => {
    //         if (ch) {
    //             pathUrl = `${pathUrl}${ch}/`;
    //         }
    //     });
    //     const redirectUrl = `${requestUrl.origin}/${pathUrl}${requestUrl.search}`;
    //     window.location.href = redirectUrl;
    // };

    // const { siteOptions } = props.config;
    // const siteOptionsUrl =
    //     (siteOptions && siteOptions[0] && siteOptions[0]?.siteRedirectUrl && siteOptions[0]?.siteRedirectUrl?.destinationUrl) || '';
    const { requestUrl } = props.context.request.url;
    const langCode = context.request.locale.toLowerCase();

    let pathUrl = requestUrl.pathname;
    if (langCode === ENGLISH_LANG_CODE) {
        pathUrl = MAORI_TOGGLE_PREFIX + pathUrl;
    } else if (langCode === MAORI_LANG_CODE) {
        pathUrl = pathUrl.replace(ENGLISH_TOGGLE_PREFIX, '');
    }
    const redirectUrl = `${requestUrl.origin}/${pathUrl}${requestUrl.search}`;
    const toggleTooltip = toggleLang === 'maori' ? 'Whakaatuhia te paetukutuku i te reo Ingarihi' : 'Display website in Te Reo Māori';
    const navArray = menuItemData;
    const atuaIndex = menuItemData?.findIndex(item => item.linkText === 'KAUWHATA ATUA');
    let subMenu: any;
    if (atuaIndex > -1) {
        subMenu = menuItemData[atuaIndex].subMenu ? menuItemData[atuaIndex].subMenu?.slice(1) : null;
    } else {
        subMenu = menuItemData[0].subMenu ? menuItemData[0].subMenu?.slice(1) : null;
    }
    const mainJSURL = `${getAsset('scripts/main.js', props.context.request)}`;
    const codeStr = `
    <div>
    <script type="application/javascript">//<![CDATA[
        const _trmhub = {}
        _trmhub.allLocales = [{"Locale":"en_NZ","Default":false,"URLSegment":"en","Title":"English"},{"Locale":"mi_NZ","Default":true,"URLSegment":"mi","Title":"Maori"}]
        //]]>
        var main = document.getElementById("main");
        main.classList.add("main");

        var body = document.getElementsByTagName("body")[0];
        body.id='body';
        body.classList.add("Education\TrmHub\Pages\HomePage");
        body.classList.add("body--HomePage");
        body.classList.add("body--global-nav");
    </script>
    <script type="text/javascript"src=${mainJSURL} defer='defer'></script>
                      
    </div>`;

    return (
        <>
            <div className='overlay' id='overlay'>
                <nav className='overlay-menu'>
                    <nav className='headerMenuMobile no-print'>
                        <div className='moe-language-toggle-holder--home-mobile'>
                            <a href={redirectUrl} role='button' className='js-i18n-toggle moe-btn-language-toggle' title={toggleTooltip}>
                                <ul className='moe-btn-language-toggle__list'>
                                    <li className={`moe-btn-language-toggle__list-item ${toggleLang === 'maori' ? 'active' : 'inactive'}`}>
                                        <span>Reo Māori</span>
                                    </li>
                                    <li className={`moe-btn-language-toggle__list-item ${toggleLang === 'maori' ? 'inactive' : 'active'}`}>
                                        <span>English</span>
                                    </li>
                                </ul>
                            </a>
                        </div>

                        <ul className='headerMenuMobile__list'>
                            <li className='headerMenuMobile__list-item'>
                                <a href={searchURL} title='Search' className='headerMenuMobile__list-link'>
                                    {KwrHomePageLanguageAttributes.searchTabName}
                                    <i className='icon--medium icon--search-white'></i>
                                </a>
                            </li>
                            <li className='headerMenuMobile__list-item'>
                                <a className='headerMenuMobile__list-link' href='#' data-target='mobile-child-atua'>
                                    {KwrHomePageLanguageAttributes.atuaTabName}
                                    <i className='icon--small icon--chevron-right-red'></i>
                                </a>
                            </li>
                            <li className='headerMenuMobile__list-item'>
                                <a className='headerMenuMobile__list-link' href='#' data-target='mobile-child-engagement'>
                                    {KwrHomePageLanguageAttributes.engageTabName}
                                    <i className='icon--small icon--chevron-right-red'></i>
                                </a>
                            </li>
                            <li className='headerMenuMobile__list-item'>
                                <a className='headerMenuMobile__list-link' href={config.curriculaLink?.destinationUrl}>
                                    {KwrHomePageLanguageAttributes.curriculaTabName}
                                    <i className='icon--small icon--chevron-right-red'></i>
                                </a>
                            </li>
                        </ul>

                        <a href='#' className='headerMenuMobile__back-link' id='mobileMenuClose'>
                            <i className='icon--small icon--chevron-left-red'></i> {KwrHomePageLanguageAttributes.backButtonText}
                        </a>
                        <ul className='headerMenuMobile__list headerMenuMobile__list--child' id='mobile-child-curricula'>
                            <div className='headerMenuMobile__child-main-title'>
                                <i className='icon icon--whata-mobile-menu'></i> {KwrHomePageLanguageAttributes.curriculaTabName}
                            </div>
                            {curriculaSubMenu &&
                                curriculaSubMenu.subMenus &&
                                curriculaSubMenu.subMenus.length > 0 &&
                                curriculaSubMenu.subMenus?.map((categoryItem: any) => {
                                    return renderMoblieCurriculaMenuItem(categoryItem);
                                })}
                        </ul>

                        <ul className='headerMenuMobile__list headerMenuMobile__list--child' id='mobile-child-atua'>
                            <div className='headerMenuMobile__child-main-title headerMenuMobile__child-main-title--atua'>
                                <i className='icon icon--whata-mobile-menu'></i> {KwrHomePageLanguageAttributes.atuaTabName}
                            </div>

                            {subMenu &&
                                subMenu.length > 0 &&
                                subMenu?.map((categoryItem: any) => {
                                    return renderMobileMenuItem(categoryItem);
                                })}
                        </ul>
                        <ul className='headerMenuMobile__list headerMenuMobile__list--child' id='mobile-child-engagement'>
                            <div className='headerMenuMobile__child-main-title'>
                                <i className='icon icon--whata-mobile-menu'></i> {KwrHomePageLanguageAttributes.engageTabName}
                            </div>
                            {engageSubMenu &&
                                engageSubMenu.subMenus &&
                                engageSubMenu.subMenus.length > 0 &&
                                engageSubMenu.subMenus?.map((categoryItem: any) => {
                                    return renderMoblieEngageMenuItem(categoryItem);
                                })}
                        </ul>
                    </nav>
                </nav>
            </div>
            <div className='button_container' id='toggle' role='button' aria-pressed='false'>
                <div className='close-text'>{KwrHomePageLanguageAttributes.closeText}</div>
                <span className='top'></span>
                <span className='middle'></span>
                <span className='bottom'></span>
            </div>

            <div id='scroller' className='scroller'></div>
            <div id='homepageIntro' className='homepage-intro'>
                <div className='homepage-intro__blurb'>
                    <div className='homepage-intro__blurb__title'>Kia māhorahora te reo Māori</div>
                    <div className='homepage-intro__blurb__subtext'>
                        {KwrHomePageLanguageAttributes.introSearchText1} <br />
                        {KwrHomePageLanguageAttributes.introSearchText2}
                    </div>

                    <div className='homepage-intro__blurb__searchbutton'>
                        <div>
                            <a className='button button--view' href={searchURL}>
                                {KwrHomePageLanguageAttributes.trySearchText}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className='page page--homepage'>
                <div className='homepage-content'>
                    <div className='homepage-atua-hover-name'>Papatūānuku</div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbRanginuiBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--ranginui'
                        ></div>
                        <div id='homepageBlurbRanginui' className='homepage-intro homepage-intro--atua homepage-intro--ranginui'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Ranginui</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextRanguini}
                                </div>
                                {fnGetCategoryURL(subMenu, 0)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbPapatuanukuBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--papatuanuku'
                        ></div>
                        <div id='homepageBlurbPapatuanuku' className='homepage-intro homepage-intro--atua homepage-intro--papatuanuku'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Papatūānuku</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextPapatuanuku}
                                </div>
                                {fnGetCategoryURL(subMenu, 1)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbTaneBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--tane'
                        ></div>
                        <div id='homepageBlurbTane' className='homepage-intro homepage-intro--atua homepage-intro--tane'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Tāne</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextTane}
                                </div>
                                {fnGetCategoryURL(subMenu, 2)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbTumatauengaBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--tumatauenga'
                        ></div>
                        <div id='homepageBlurbTumatauenga' className='homepage-intro homepage-intro--atua homepage-intro--tumatauenga'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Tūmatauenga</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextTumatauenga}
                                </div>
                                {fnGetCategoryURL(subMenu, 3)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbRongoBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--rongo'
                        ></div>
                        <div id='homepageBlurbRongo' className='homepage-intro homepage-intro--atua homepage-intro--rongo'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Rongo</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextRongo}
                                </div>
                                {fnGetCategoryURL(subMenu, 4)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbHaumiaBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--haumia'
                        ></div>
                        <div id='homepageBlurbHaumia' className='homepage-intro homepage-intro--atua homepage-intro--haumia'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Haumia</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextHaumia}
                                </div>
                                {fnGetCategoryURL(subMenu, 5)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbTawhirimateaBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--tawhirimatea'
                        ></div>
                        <div id='homepageBlurbTawhirimatea' className='homepage-intro homepage-intro--atua homepage-intro--tawhirimatea'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Tāwhirimātea</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextTawhirimatea}
                                </div>
                                {fnGetCategoryURL(subMenu, 6)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbTangaroaBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--tangaroa'
                        ></div>
                        <div id='homepageBlurbTangaroa' className='homepage-intro homepage-intro--atua homepage-intro--tangaroa'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Tangaroa</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextTangaroa}
                                </div>
                                {fnGetCategoryURL(subMenu, 7)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbRuaumokoBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--ruaumoko'
                        ></div>
                        <div id='homepageBlurbRuaumoko' className='homepage-intro homepage-intro--atua homepage-intro--ruaumoko'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Rūaumoko</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextRuaumoko}
                                </div>
                                {fnGetCategoryURL(subMenu, 8)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbWhiroBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--whiro'
                        ></div>
                        <div id='homepageBlurbWhiro' className='homepage-intro homepage-intro--atua homepage-intro--whiro'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Whiro</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextWhiro}
                                </div>
                                {fnGetCategoryURL(subMenu, 9)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-intro-atua-blurb-container'>
                        <div
                            id='homepageBlurbHineahuoneBackdrop'
                            className='homepage-intro--atua-backdrop homepage-intro--atua-backdrop-- homepage-intro--atua-backdrop--hineahuone'
                        ></div>
                        <div id='homepageBlurbHineahuone' className='homepage-intro homepage-intro--atua homepage-intro--hineahuone'>
                            <div className='homepage-intro__blurb homepage-intro__blurb--'>
                                <div className='homepage-intro__blurb__title homepage-intro__blurb__title--'>Hineahuone</div>
                                <div className='homepage-intro__blurb__subtext homepage-intro__blurb__subtext--'>
                                    {KwrHomePageLanguageAttributes.introAtuaBlurbTextHineahuone}
                                </div>
                                {fnGetCategoryURL(subMenu, 10)}
                            </div>
                        </div>
                    </div>

                    <div className='homepage-whatas'>
                        <div className='whata whata--atua' style={{ transform: 'translateZ(0px)' }}>
                            <img
                                className='whata__image'
                                src={getAsset('images/whatas/whata-left.svg', props.context.request)}
                                alt='Whata'
                            />
                            <img
                                className='whata__image whata__image--hover'
                                src={getAsset('images/whatas/whata-left-hover.svg', props.context.request)}
                                alt='Whata on hover'
                            />
                            <button
                                tabIndex={1}
                                className='whata__button'
                                data-class='active'
                                data-toggle='.mega--atua'
                                data-toggled='false'
                                onClick={() => setCategoryMemuIsActive(true)}
                            >
                                <span className='whata__button-text'>{KwrHomePageLanguageAttributes.atuaTabName}</span>
                            </button>
                        </div>
                        <div className='whata whata--patoro' style={{ transform: 'translateZ(0px)' }}>
                            <img
                                className='whata__image'
                                src={getAsset('images/whatas/whata-left.svg', props.context.request)}
                                alt='Whata'
                            />
                            <img
                                className='whata__image whata__image--hover'
                                src={getAsset('images/whatas/whata-left-hover.svg', props.context.request)}
                                alt='Whata on hover'
                            />{' '}
                            <button
                                tabIndex={2}
                                className='whata__button'
                                data-class='active'
                                data-toggle='.mega--newsEvents'
                                data-toggled='false'
                                onClick={() => setEngageMenuIsActive(true)}
                            >
                                <span className='whata__button-text'>{KwrHomePageLanguageAttributes.engageTabName}</span>
                            </button>
                        </div>
                        <div className='whata whata--marau' style={{ transform: 'translateZ(0px)' }}>
                            <img
                                className='whata__image'
                                src={getAsset('images/whatas/whata-right.svg', props.context.request)}
                                alt='Whata'
                            />
                            <img
                                className='whata__image whata__image--hover'
                                src={getAsset('images/whatas/whata-right-hover.svg', props.context.request)}
                                alt='Whata on hover'
                            />{' '}
                            <a
                                tabIndex={3}
                                className='whata__button'
                                href={config.curriculaLink?.destinationUrl}
                                title={KwrHomePageLanguageAttributes.curriculaTabName}
                            >
                                <span className='whata__button-text'>{KwrHomePageLanguageAttributes.curriculaTabName}</span>
                            </a>
                        </div>
                        <div className='whata whata--whatora' style={{ transform: 'translateZ(0px)' }}>
                            <img
                                className='whata__image'
                                src={getAsset('images/whatas/whata-right.svg', props.context.request)}
                                alt='Whata'
                            />
                            <img
                                className='whata__image whata__image--hover'
                                src={getAsset('images/whatas/whata-right-hover.svg', props.context.request)}
                                alt='Whata on hover'
                            />
                            <a tabIndex={4} className='whata__button' href={searchURL} title='Search'>
                                <span className='whata__button-text'>
                                    <i className='icon icon--search-light'></i>
                                    {KwrHomePageLanguageAttributes.searchTabName}
                                </span>
                            </a>
                        </div>
                    </div>
                    <div className='hills'>
                        <div className='hill hill--left hill--back' style={{ transform: 'translateZ(0px)' }}></div>
                        <div className='hill hill--left hill--middle' style={{ transform: 'translateZ(0px)' }}></div>
                        <div className='hill hill--left hill--front' style={{ transform: 'translateZ(0px)' }}></div>

                        <div className='hill hill--right hill--back' style={{ transform: 'translateZ(0px)' }}></div>
                        <div className='hill hill--right hill--middle' style={{ transform: 'translateZ(0px)' }}></div>
                        <div className='hill hill--right hill--front' style={{ transform: 'translateZ(0px)' }}></div>
                    </div>
                    <div className='pathway'>
                        <div className='pathway__inner'>
                            <div id='pathwayWeave' className='pathway__weave-wrapper' style={{ transform: 'translateZ(0px)' }}>
                                <div id='pathwayWeave' className='pathway__weave'>
                                    <div className='pathway__weave__ranginui'></div>
                                    <div className='pathway__weave__papatuanuku'></div>
                                    <div className='pathway__weave__tangaroa'></div>
                                    <div className='pathway__weave__tane'></div>
                                    <div className='pathway__weave__tumatauenga'></div>
                                    <div className='pathway__weave__rongo'></div>
                                    <div className='pathway__weave__haumia'></div>
                                    <div className='pathway__weave__tawhirimatea'></div>
                                    <div className='pathway__weave__hineahuone'></div>
                                    <div className='pathway__weave__whiro'></div>
                                    <div className='pathway__weave__ruaumoko'></div>
                                    <div className='pathway__weave__spacer'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--90'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--80'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--70'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--60'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--50'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--40'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--30'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--20'></div>
                                    <div className='pathway__weave__spacer pathway__weave__spacer--10'></div>
                                </div>
                            </div>
                            <div className='pathway__weave pathway__weave--orange'></div>
                            <div className='pathway__atuas' style={{ transform: 'translateZ(0px)' }}>
                                <a
                                    id='atuaRanginui'
                                    role='button'
                                    data-atua-name='Ranginui'
                                    data-atuaopacity='1'
                                    data-scrollposition='100'
                                    data-atuablurb='homepageBlurbRanginui'
                                    data-atuablurbbackdrop='homepageBlurbRanginuiBackdrop'
                                    className='pathway__atua pathway__atua--ranginui pathway__atua--row-1 pathway__atua--right'
                                    title='Learn more about this Atua'
                                    style={{ pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/ranginui-with-shadow.png', props.context.request)} alt='Ranginui' />{' '}
                                </a>

                                <a
                                    id='atuaPapatuanuku'
                                    role='button'
                                    data-atua-name='Papatūānuku'
                                    data-atuaopacity='0.9'
                                    data-scrollposition='825'
                                    data-atuablurb='homepageBlurbPapatuanuku'
                                    data-atuablurbbackdrop='homepageBlurbPapatuanukuBackdrop'
                                    className='pathway__atua pathway__atua--papatuanuku pathway__atua--row-2 pathway__atua--left'
                                    title='Learn more about this Atua'
                                    style={{ pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img
                                        src={getAsset('images/atuas/papatuanuku-with-shadow.png', props.context.request)}
                                        alt='Papatūānuku'
                                    />{' '}
                                </a>

                                <a
                                    id='atuaTane'
                                    role='button'
                                    data-atua-name='Tāne'
                                    data-atuaopacity='0.7'
                                    data-scrollposition='2150'
                                    data-atuablurb='homepageBlurbTane'
                                    data-atuablurbbackdrop='homepageBlurbTaneBackdrop'
                                    className='pathway__atua pathway__atua--tane pathway__atua--row-4 pathway__atua--left'
                                    title='Learn more about this Atua'
                                    style={{ pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/tane-with-shadow.png', props.context.request)} alt='Tāne' />{' '}
                                </a>

                                <a
                                    id='atuaTumatauenga'
                                    role='button'
                                    data-atua-name='Tūmatauenga'
                                    data-atuaopacity='0.6'
                                    data-scrollposition='2750'
                                    data-atuablurb='homepageBlurbTumatauenga'
                                    data-atuablurbbackdrop='homepageBlurbTumatauengaBackdrop'
                                    className='pathway__atua pathway__atua--tumatauenga pathway__atua--row-5 pathway__atua--right'
                                    title='Learn more about this Atua'
                                    style={{ pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img
                                        src={getAsset('images/atuas/tumatauenga-with-shadow.png', props.context.request)}
                                        alt='Tūmatauenga'
                                    />{' '}
                                </a>

                                <a
                                    id='atuaRongo'
                                    role='button'
                                    data-atua-name='Rongo'
                                    data-atuaopacity='0.5'
                                    data-scrollposition='3410'
                                    data-atuablurb='homepageBlurbRongo'
                                    data-atuablurbbackdrop='homepageBlurbRongoBackdrop'
                                    className='pathway__atua pathway__atua--rongo pathway__atua--row-6 pathway__atua--left'
                                    title='Learn more about this Atua'
                                    style={{ opacity: 0.60084, pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/rongo-with-shadow.png', props.context.request)} alt='Rongo' />{' '}
                                </a>

                                <a
                                    id='atuaHaumia'
                                    role='button'
                                    data-atua-name='Haumia'
                                    data-atuaopacity='0.4'
                                    data-scrollposition='4050'
                                    data-atuablurb='homepageBlurbHaumia'
                                    data-atuablurbbackdrop='homepageBlurbHaumiaBackdrop'
                                    className='pathway__atua pathway__atua--haumia pathway__atua--row-7 pathway__atua--right'
                                    title='Learn more about this Atua'
                                    style={{ opacity: 0.50084, pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/haumia-with-shadow.png', props.context.request)} alt='Haumia' />{' '}
                                </a>

                                <a
                                    id='atuaTawhirimatea'
                                    role='button'
                                    data-atua-name='Tāwhirimātea'
                                    data-atuaopacity='0.3'
                                    data-scrollposition='4710'
                                    data-atuablurb='homepageBlurbTawhirimatea'
                                    data-atuablurbbackdrop='homepageBlurbTawhirimateaBackdrop'
                                    className='pathway__atua pathway__atua--tawhirimatea pathway__atua--row-8 pathway__atua--left'
                                    title='Learn more about this Atua'
                                    style={{ opacity: 0.55084, pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img
                                        src={getAsset('images/atuas/tawhirimatea-with-shadow.png', props.context.request)}
                                        alt='Tāwhirimātea'
                                    />{' '}
                                </a>

                                <a
                                    id='atuaTangaroa'
                                    role='button'
                                    data-atua-name='Tangaroa'
                                    data-atuaopacity='0.8'
                                    data-scrollposition='1500'
                                    data-atuablurb='homepageBlurbTangaroa'
                                    data-atuablurbbackdrop='homepageBlurbTangaroaBackdrop'
                                    className='pathway__atua pathway__atua--tangaroa pathway__atua--row-3 pathway__atua--right'
                                    title='Learn more about this Atua'
                                    style={{ opacity: 0.90084, pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/tangaroa-with-shadow.png', props.context.request)} alt='Tangaroa' />{' '}
                                </a>

                                <a
                                    id='atuaRuaumoko'
                                    role='button'
                                    data-atua-name='Rūaumoko'
                                    data-atuaopacity='0.1'
                                    data-scrollposition='6683'
                                    data-atuablurb='homepageBlurbRuaumoko'
                                    data-atuablurbbackdrop='homepageBlurbRuaumokoBackdrop'
                                    className='pathway__atua pathway__atua--ruaumoko pathway__atua--row-11 pathway__atua--right'
                                    title='Learn more about this Atua'
                                    style={{ opacity: 0.35084, pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/ruaumoko-with-shadow.png', props.context.request)} alt='Rūaumoko' />{' '}
                                </a>

                                <a
                                    id='atuWhiro'
                                    role='button'
                                    data-atua-name='Whiro'
                                    data-atuaopacity='0.1'
                                    data-scrollposition='5962'
                                    data-atuablurb='homepageBlurbWhiro'
                                    data-atuablurbbackdrop='homepageBlurbWhiroBackdrop'
                                    className='pathway__atua pathway__atua--whiro pathway__atua--row-10 pathway__atua--left'
                                    title='Learn more about this Atua'
                                    style={{ opacity: '0.35084' }}
                                    tabIndex={0}
                                >
                                    <img src={getAsset('images/atuas/whiro-with-shadow.png', props.context.request)} alt='Whiro' />{' '}
                                </a>

                                <a
                                    id='atuaHineahuone'
                                    role='button'
                                    data-atua-name='Hineahuone'
                                    data-atuaopacity='0.2'
                                    data-scrollposition='5334'
                                    data-atuablurb='homepageBlurbHineahuone'
                                    data-atuablurbbackdrop='homepageBlurbHineahuoneBackdrop'
                                    className='pathway__atua pathway__atua--hineahuone pathway__atua--row-9 pathway__atua--right'
                                    title='Learn more about this Atua'
                                    style={{ opacity: '0.45084', pointerEvents: 'all' }}
                                    tabIndex={0}
                                >
                                    <img
                                        src={getAsset('images/atuas/hineahuone-with-shadow.png', props.context.request)}
                                        alt='Hineahuone'
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ul className='mega-dropdowns'>
                <CategoryModal
                    index={0}
                    menuName={'Kauwhata'}
                    subMenuItems={subMenu}
                    renderButton={() => {
                        <button tabIndex={1} id='atuaToggle' className='header-menu__mega-nav-toggler'>
                            <span>{navArray[0].linkText}</span>
                        </button>;
                    }}
                    buttonClassname={'header-menu__mega-nav-toggler'}
                    context={props.context}
                    id={'1'}
                    typeName={'2'}
                    data={[]}
                    isModalOpen={categoryMemuIsActive}
                    btnCloseClick={() => setCategoryMemuIsActive(false)}
                    KwrHomePageLanguageAttributes={KwrHomePageLanguageAttributes}
                    preferredLanguage={preferredLanguage}
                ></CategoryModal>
                {engageSubMenu && (
                    <EnagageModal
                        index={0}
                        menuName={'Engage'}
                        subMenuItems={engageSubMenu}
                        renderButton={() => {
                            <button tabIndex={1} id='atuaToggle' className='header-menu__mega-nav-toggler'>
                                <span>{navArray[0].linkText}</span>
                            </button>;
                        }}
                        buttonClassname={'header-menu__mega-nav-toggler'}
                        context={props.context}
                        id={'1'}
                        typeName={'2'}
                        data={[]}
                        isModalOpen={engageMenuIsActive}
                        btnCloseClick={() => closeEngageMenu()}
                        KwrHomePageLanguageAttributes={KwrHomePageLanguageAttributes}
                        preferredLanguage={preferredLanguage}
                    ></EnagageModal>
                )}
                {curriculaSubMenu && (
                    <CurriculaModal
                        index={0}
                        menuName={'Engage'}
                        subMenuItems={curriculaSubMenu}
                        renderButton={() => {
                            <button tabIndex={1} id='atuaToggle' className='header-menu__mega-nav-toggler'>
                                <span>{navArray[0].linkText}</span>
                            </button>;
                        }}
                        context={props.context}
                        id={'1'}
                        typeName={'2'}
                        data={[]}
                        isModalOpen={curriculaMenuIsActive}
                        btnCloseClick={() => setCurriculaMenuIsActive(false)}
                        KwrHomePageLanguageAttributes={KwrHomePageLanguageAttributes}
                        preferredLanguage={preferredLanguage}
                    ></CurriculaModal>
                )}
            </ul>
            <div className='moe-language-toggle-holder--home-desktop'>
                <a href={redirectUrl} role='button' className='js-i18n-toggle moe-btn-language-toggle' title={toggleTooltip}>
                    <ul className='moe-btn-language-toggle__list'>
                        <li className={`moe-btn-language-toggle__list-item ${toggleLang === 'maori' ? 'active' : 'inactive'}`}>
                            <span>Reo Māori</span>
                        </li>
                        <li className={`moe-btn-language-toggle__list-item ${toggleLang === 'maori' ? 'inactive' : 'active'}`}>
                            <span>English</span>
                        </li>
                    </ul>
                </a>
            </div>
            <div className='paekupu-modal'></div>

            <div dangerouslySetInnerHTML={{ __html: codeStr }} />
        </>
    );

    function closeEngageMenu() {
        setEngageMenuIsActive(false);
    }

    function fnGetCategoryURL(subMenu: IMenuItemData[] | null, atuaIndex: number) {
        const linkURL = subMenu && subMenu[atuaIndex] ? subMenu[atuaIndex].linkURL : '';
        return (
            <a className='button button button--view button--atuaSearch' href={linkURL} tabIndex={-1}>
                {KwrHomePageLanguageAttributes.introAtuaSearchText}
            </a>
        );
    }

    function renderMobileMenuItem(categoryItem: any) {
        const categoryImageUrl = generateImageUrl(`${categoryItem.imageSource}`, props.context.actionContext.requestContext.apiSettings);
        return (
            <>
                <li className='headerMenuMobile__child-item'>
                    <a
                        href={categoryItem.linkURL}
                        className='headerMenuMobile__child-link headerMenuMobile__child-link--atua'
                        title={categoryItem.linkText}
                    >
                        <span className='headerMenuMobile__atua-image-wrapper'>
                            <img
                                src={categoryImageUrl}
                                alt={categoryItem.linkText}
                                //title={categoryItem.linkText}
                                className='headerMenuMobile__atua-image'
                            ></img>{' '}
                        </span>
                        <span className='headerMenuMobile__atua-title'> {categoryItem.linkText}</span>
                    </a>
                </li>
            </>
        );
    }

    function renderMoblieCurriculaMenuItem(menuItem: any) {
        return (
            <>
                <div className='headerMenuMobile__child-sub-heading'>{menuItem.linkText}</div>

                {renderMobileCurriculaSubMenuItems(menuItem)}
            </>
        );
    }

    function renderMobileCurriculaSubMenuItems(subMenuItem: any) {
        return (
            <>
                {subMenuItem &&
                    subMenuItem.subMenus &&
                    subMenuItem.subMenus.length > 0 &&
                    subMenuItem.subMenus?.map((subMenu: any, idx: number) => {
                        return (
                            <>
                                <li className='headerMenuMobile__child-item'>
                                    <a href={subMenu?.linkUrl?.destinationUrl} className='headerMenuMobile__child-link'>
                                        {subMenu.linkText}
                                        <i className='icon--small icon--external-link-grey'></i>
                                    </a>
                                </li>
                            </>
                        );
                    })}
            </>
        );
    }

    function renderMoblieEngageMenuItem(menuItem: any) {
        return (
            <>
                <div className='headerMenuMobile__child-sub-heading'>{menuItem.linkText}</div>
                {renderMobileEngageSubMenuItems(menuItem)}
            </>
        );
    }

    function renderMobileEngageSubMenuItems(subMenuItem: any) {
        return (
            <>
                {subMenuItem &&
                    subMenuItem.subMenus &&
                    subMenuItem.subMenus.length > 0 &&
                    subMenuItem.subMenus?.map((subMenu: any, idx: number) => {
                        return (
                            <>
                                <li className='headerMenuMobile__child-item' key={idx}>
                                    <a className='headerMenuMobile__child-link' href={subMenu?.linkUrl?.destinationUrl}>
                                        {subMenu.linkText}
                                    </a>
                                </li>
                            </>
                        );
                    })}
            </>
        );
    }
};
